import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select/creatable'

import Form from 'component/utils/Form'
import Field from 'component/utils/Field'

import CustomInputFile from 'component/utils/CustomInputFile'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

const FIELDS = ['nmBrand', 'logo']

const ACCENT_MAP = {
  a: /[\xE0-\xE6]/g,
  e: /[\xE8-\xEB]/g,
  i: /[\xEC-\xEF]/g,
  o: /[\xF2-\xF6]/g,
  u: /[\xF9-\xFC]/g,
  c: /\xE7/g,
  n: /\xF1/g,
}

class LogoBrandsForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      logoBrandsList: [],
    }
  }

  componentDidMount = () => {
    const { user } = this.props

    if (user) {
      return new Api(user.dsToken)
        .get(API_URL.FETCH_ALL_LOGO_BRANDS)
        .then((response) => this.setState({ logoBrandsList: response.data }))
    }
  }

  beforeHandleSubmit = (event) => {
    const { values, resetForm, handleSubmit } = this.props

    event.preventDefault()

    let formattedName = values.nmBrand.value.toLowerCase()

    Object.entries(ACCENT_MAP).forEach((accent) => {
      formattedName = formattedName.replace(accent[1], accent[0])
    })

    formattedName = formattedName.replace(/[\W_]/g, '')

    const newValues = { ...values, nmBrand: { value: formattedName } }

    handleSubmit(newValues, resetForm)
  }

  handleFileChange = async (event) => {
    const { setValueToField } = this.props

    const file = event.target.files[0]

    const fileToPreview = await new Promise((resolve) => {
      const reader = new FileReader()

      reader.onloadend = ({ target: { result } }) => resolve(result)

      reader.readAsDataURL(file)
    })

    setValueToField('logo', {
      fileToPreview,
      fileToUpload: file,
      name: file.name,
    })
  }

  clearImage = () => {
    this.props.setValueToField('logo', null)
  }

  render() {
    const { translate, fields, values, setValueToField } = this.props

    return (
      <form onSubmit={this.beforeHandleSubmit}>
        <h3>{translate('datasheetManagement.logoBrands.newLogo')}</h3>

        <Field {...fields.nmBrand}>
          <Select
            className='react-select'
            classNamePrefix='react-select'
            formatCreateLabel={(string) =>
              `${translate('datasheetManagement.logoBrands.create')} ${string}`
            }
            id='nm-brand'
            menuPortalTarget={document.body}
            name='nmBrand'
            onChange={(option) => setValueToField('nmBrand', option)}
            options={this.state.logoBrandsList.map(({ nmBrand }) => ({
              value: nmBrand,
              label: nmBrand,
            }))}
            placeholder=''
            isClearable='true'
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            value={values.nmBrand}
          />

          <em htmlFor='nm-brand'>{translate('provider')}</em>
        </Field>

        <Field {...fields.logo}>
          <CustomInputFile
            name='logo'
            filePreview={values.logo}
            handleFileChange={this.handleFileChange}
            translate={translate}
            clearImage={this.clearImage}
          />
        </Field>

        <button
          disabled={!values.nmBrand || !values.logo}
          className='button button-primary button-full'
        >
          {translate('send')}
        </button>
      </form>
    )
  }
}

LogoBrandsForm.propTypes = {
  translate: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(LogoBrandsForm)

export { LogoBrandsForm }
